<template>
  <!-- 优惠专区模块 -->
  <div class="discount-box main mt30">
    <div class="discount-left">
      <img src="../assets/imgs/banner-s1.png" width="100%" height="100%" />
    </div>
    <div class="discount-right">
      <ul class="tabs">
        <li
          :class="i === index ? 'active-tab' : ''"
          @mouseenter="
            i = index;
            changeProducts(item.id);
          "
          v-for="(item, index) in tabsList"
          :key="index"
        >
          {{ item.title }}
        </li>
      </ul>
      <a-empty v-if="productList.length === 0" class="mt30" />
      <div class="product-list" v-else>
        <product-box
          v-for="(product, index) in productList"
          :key="index"
          :productObj="product"
          @goDetail="goDetail(product)"
        ></product-box>
      </div>
    </div>
  </div>
</template>
<script>
import productBox from '@/components/productBox'
import { getRd } from '@/serve/home'
import { shopSkusList } from '@/serve/shop'
import { mapState } from 'vuex'

export default {
  name: 'discountBox',
  components: {
    productBox
  },
  computed: {
    ...mapState({
      loginType: state => state.user.loginType,
      ageStage: state => state.user.ageStage,
      blocTagBlocId: state => state.user.blocTagBlocId
    })
  },
  data () {
    return {
      tabsList: [
        { title: '精选商品', id: 1 }
        // { title: '精品文具', id: 2 },
        // { title: '品牌精选', id: 3 },
        // { title: '孩子最爱', id: 4 },
        // { title: '家长最爱', id: 5 }
      ],
      productList: [],
      i: 0
    }
  },
  methods: {
    goDetail (val) {
      this.$router.push({ path: '/product/' + val.sku })
    },
    changeProducts (i) {
      // this.productList = []
      // getRd({ page: i - 1, rows: 4 }).then(res => {
      //   res.forEach(item => {
      //     shopSkusDetail(item).then(response => {
      //       this.productList.push(response)
      //     })
      //   })
      // })
    },
    init () {
      let tempName = []
      getRd({ page: 0, shoperType: this.loginType, ageStage: this.ageStage, blocTagBlocId: this.blocTagBlocId, type: 'CHOICENESS' }).then(res => {
        let skus = res.join(',')
        shopSkusList({ skus }).then(data => {
          let pid2product = {}
          data.forEach(pd => { pid2product[pd.sku] = pd })
          for (let sku of res) {
            let item = pid2product[sku]
            if (tempName.indexOf(item.productId) === -1) {
              tempName.push(item.productId)
              if (this.productList.length < 4) {
                this.productList.push(item)
              }
            }
          }
        })
      })
    }
  },
  created () {
    this.init()
  }
}
</script>
<style lang="less" scoped>

.product-list{
  display: flex;
}
.discount-box {
  box-shadow: 0 0 5px #e6e6e6;
  display: flex;
  height: 392px;
  .discount-left {
    width: 250px;
    display: inline-block;
    img {
      // vertical-align: top;
    }
  }
  .discount-right {
    width: 940px;
    display: inline-block;
    padding-bottom: 20px;
    ul {
      margin: 0;
      padding: 20px;
      li {
        display: inline-block;
        margin-right: 20px;
        font-size: 18px;
        cursor: pointer;
        &:hover {
          color: skyblue;
        }
      }
      .active-tab {
        color: skyblue;
      }
    }
  }
}
</style>
